import './_easings';
import {getOffset} from './_getOffset';
import skrollTop from 'skrollTop';
export function slideList() {

  const DOMAnimations = {
    
    /**
    * SlideUp
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideUp: function (element, duration = 1200, timing = 'cubic-bezier(0.86, 0, 0.07, 1)') {
      return new Promise(function (resolve, reject) {
        document.body.classList.add('is-animate');
        element.style.height = element.offsetHeight + 'px';
        element.style.transitionProperty = `height, margin, padding`;
        element.style.transitionDuration = duration + 'ms';
        element.style.transitionTimingFunction = timing;
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        window.setTimeout(function () {
          document.body.classList.remove('is-animate');
          element.classList.remove('is-show');
          element.classList.add('is-hide');
          element.style.removeProperty('height');
          element.style.removeProperty('padding-top');
          element.style.removeProperty('padding-bottom');
          element.style.removeProperty('margin-top');
          element.style.removeProperty('margin-bottom');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition-duration');
          element.style.removeProperty('transition-property');
          resolve(false);
        }, duration)
      })
    },

    /**
    * SlideDown
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideDown: function (element, duration = 1200, timing = 'cubic-bezier(0.86, 0, 0.07, 1)') {
      return new Promise(function (resolve, reject) {
        document.body.classList.add('is-animate');
        element.style.removeProperty('display');
        let display = window.getComputedStyle(element).display;
        if(display === 'none') 
          element.classList.remove('is-hide');
          element.classList.add('is-show');
        let height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        element.offsetHeight;
        element.style.transitionProperty = `height, margin, padding`;
        element.style.transitionDuration = duration + 'ms';
        element.style.transitionTimingFunction = timing;
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        window.setTimeout(function () {
          document.body.classList.remove('is-animate');
          element.style.removeProperty('height');
          element.style.removeProperty('overflow');
          element.style.removeProperty('transition-duration');
          element.style.removeProperty('transition-property');
        }, duration)
      })
    },

    /**
    * SlideToggle
    *
    * @param {HTMLElement} element
    * @param {Number} duration
    * @returns {Promise<boolean>}
    */
    slideToggle: function (element, duration = 1200, timing = 'cubic-bezier(0.83, 0, 0.17, 1)') {
      if (window.getComputedStyle(element).display === 'none') {
        return this.slideDown(element, duration, timing);
      } else {
        return this.slideUp(element, duration, timing);
      }
    }
  }

  /* config */
  const lists = document.querySelectorAll('.js-slide-list');
  const currentClass = 'is-active';

  for(let i = 0; i < lists.length; i++) {
    const list = lists[i];
    const trigger = list.querySelectorAll('.js-slide-list-trigger');
    const content = list.querySelector('.js-slide-list-content');
    if(trigger) {
      for(let i = 0; i < trigger.length; i++) {
        const _trigger = trigger[i];
        _trigger.addEventListener('click', function(e) {
          if(!document.body.classList.contains('is-animate')) {
            if(list.classList.contains(currentClass)) {
              for(let i = 0; i < lists.length; i++) {
                const list = lists[i];
                const content = list.querySelector('.js-slide-list-content');
                list.classList.remove(currentClass);
                content.classList.remove(currentClass);
              }
              content.classList.remove(currentClass);
              const scTop =(document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
              const listOffset = getOffset(list);
              const listOffsetTop = listOffset.top;
              if(scTop >= listOffsetTop) {
                skrollTop.scrollTo({
                  to: listOffsetTop,
                  easing: window.easings.easeInOutQuint,
                  duration: 1200
                });
              }
            } else {
              for(let i = 0; i < lists.length; i++) {
                const list = lists[i];
                const content = list.querySelector('.js-slide-list-content');
                list.classList.remove(currentClass);
                content.classList.remove(currentClass);
              }
              list.classList.add(currentClass);
              content.classList.add(currentClass);
            }

            for(let ii = 0; ii < lists.length; ii++) {
              if(i !== ii) {
                const el = lists[ii];
                const target = el.querySelector('.js-slide-list-content');
                DOMAnimations.slideUp(target);
              }
            }
            DOMAnimations.slideToggle(content);
          }

          e.preventDefault()
        })
      }
    }
  }
}